import { Component, Input, OnInit } from '@angular/core';

import { Item } from '../../../../../canvas/components/transition-matrix/items/item';
import { ItemsService } from '../../../../../canvas/components/transition-matrix/items/items.service';

@Component({
  selector: 'app-keynote-matrix',
  templateUrl: './keynote-matrix.component.html',
  styleUrls: ['./keynote-matrix.component.css']
})
export class KeynoteMatrixComponent implements OnInit {

  @Input() onShowPeriod;
  windowWith;
  items: Item [];
  mockItems: Item [] = [];

  constructor(
    private _itemsService: ItemsService) {}

    getItems(): void {
    this._itemsService.getItems().then(items => this.items = items);
  }

  getMockItems(): void {
    this._itemsService.getMockItems().then(mockItems => this.mockItems = mockItems);
  }

  ngOnInit(): void {
    this.windowWith = window.innerWidth;
    this.getMockItems();
    this.getItems();
  }

  onResize(event) {
    this.windowWith = event.target.innerWidth;
  }

  breakRow(theArr: any[]) {
    const arrOfarr = [];
    if (this.windowWith > 768) {
      for (let i = 0; i < theArr.length ; i+=3) {
        const row = [];
        for (let x = 0; x < 3; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } else if (this.windowWith > 480) {
      for (let i = 0; i < theArr.length ; i+=2) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 2; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } else {
      for (let i = 0; i < theArr.length ; i+=1) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 1; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    }
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/keynote/components/transition/components/keynote-matrix/keynote-matrix.component.ts